import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CountryLanguageHelper } from '../../utils/country-language/country-language-helper';

@Injectable({ providedIn: 'root' })
export class LanguageModalHelper {
  countryLanguageHelper = inject(CountryLanguageHelper);

  openFlyoutLang = new BehaviorSubject({
    openFlyoutConfirmationModal: false,
    countryCode: '',
    languageCode: '',
    secondaryLanguageCode: ''
  });

  showModalIfNeeded(countryCode: string | null): void {
    if (!this.shouldShowModal(countryCode)) return;

    const browserLang =
      this.countryLanguageHelper.getLanguageCodeFromPrefCookie();
    const primaryLang = this.countryLanguageHelper.getPrimaryLanguage(
      countryCode as string
    );
    const secondaryLang = this.countryLanguageHelper.getSecondaryLanguage(
      countryCode as string
    );

    if (browserLang && primaryLang) {
      this.determineModalLanguages(
        countryCode as string,
        browserLang,
        primaryLang.languageCode,
        secondaryLang
      );
    }
  }

  private shouldShowModal(countryCode: string | null): boolean {
    return !!(
      this.countryLanguageHelper.shouldShowConfirmationModal() && countryCode
    );
  }

  private determineModalLanguages(
    countryCode: string,
    browserLang: string,
    primaryLangCode: string,
    secondaryLang: string | null
  ): void {
    browserLang !== primaryLangCode
      ? this.openModal(countryCode, browserLang, primaryLangCode)
      : secondaryLang &&
        this.openModal(countryCode, browserLang, secondaryLang);
  }

  openModal(
    countryCode: string,
    languageCode: string,
    secondaryCode: string
  ): void {
    this.openFlyoutLang.next({
      openFlyoutConfirmationModal: true,
      countryCode,
      languageCode,
      secondaryLanguageCode: secondaryCode
    });
  }
}
